module.exports = __webpack_public_path__ + "static/media/like_icon_selected.67da0ac1.svg";